export enum PippaAnalyticsEvent {
  USER_PLATFORM = "user_platform",
  CHATBOT_INGRESS = "chatbot_ingress",
  CHATBOT_CONSENT_YES = "chatbot_consent_yes",
  CHATBOT_CONSENT_CLOSED = "chatbot_consent_closed",
  CHATBOT_BANNER_SHOWN = "chatbot_banner_shown",
  CHATBOT_CLOSED = "chatbot_closed",
  CHATBOT_LINKS = "chatbot_links",
}

export enum PippaIngressSource {
  AI_ASSISTANT_BANNER = "ai_assistant_banner",
  AUTO_OPEN_POST_PDF = "auto_open_post_pdf",
}
